<template>
  <div class="table">
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <i class="el-icon-lx-cascades"></i> 工单统计
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="container">
      <div class="app-container">
        <div style="margin-bottom: 20px">
          <el-input v-model="listQuery.deal_user" placeholder="处理人" style="width:200px;margin-right:20px;"></el-input>
            <el-date-picker
                    v-model="listQuery.date"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
            </el-date-picker>
          <el-button
                  class="filter-item"
                  style="margin-left: 10px;"
                  type="primary"
                  icon="el-icon-search"
                  @click="handleFilter"
          >搜索</el-button>
          <el-button
                  class="filter-item"
                  style="background-color:#00bfbf;color:white;float:right;"
                  @click="setTime"
                  v-if="set_time_button"
          >时间限制</el-button>
        </div>

        <setTimeRange 
        :timeOptions="timeOptions"  
        :setTimeShow="setTimeShow" 
        @deleteTime="deleteTime" 
        @addTime="addTime" 
        @removeTime="removeTime" 
        @sureTime="sureTime" 
        @closeTimeShow="closeTimeShow">
        </setTimeRange>

        <el-table border v-loading="listLoading"  min-height="200"  max-height="1000" :data="tableData" @sort-change="changeSort" style="width: 100%">
            <el-table-column prop="date" label="日期" />
            <el-table-column prop="deal_user" label="处理人" />
            <el-table-column prop="deal_num" label="处理数" sortable @sort-method="changeSort"/>
            <el-table-column prop="operate_num" label="操作数" sortable @sort-method="changeSort"/>
            <el-table-column prop="average_time_text" label="平均处理时长" sortable @sort-method="changeSort"/>
            <el-table-column prop="average_response_time_text" label="平均响应时长" sortable @sort-method="changeSort"/>
            <el-table-column prop="wrong_number" label="出错数" sortable @sort-method="changeSort"/>
            <el-table-column prop="wrong_rate_text" label="出错率" sortable @sort-method="changeSort"/>
        </el-table>

        <pagination
          v-show="total>0"
          :total="total"
          :page.sync="listQuery.page"
          :limit.sync="listQuery.limit"
          @pagination="handleList"
        />
      </div>
    </div>
  </div>
</template>

<script>
import {
    handleListApi,
} from "@/api/work_statistics.js";
import { getTimeApi, setTimeApi} from "@/api/setTime.js"

import setTimeRange from "@/components/common/setTimeRange";
import Pagination from "@/components/pagination/index";
    export default {
        components: { Pagination,setTimeRange },
        name: "work_statistics",
        data() {
        return {
            // 列表
            listLoading: false,
            total: 0,
            tableData: [],
            listQuery: {
                deal_user:"",
                date:[],
                sort:"",
                order:"",
                page: 1,
                limit: 10
            },
            // 时间设置
            timeOptions:[],
            setTimeShow:false,
            set_time_button:false,
        };
    },
    created() {
        this.handleList(this.listQuery);
    },
    methods: {
        handleList() {
            this.listLoading = true;
            handleListApi(this.listQuery)
            .then(response => {
                const data = response.data.data;
                this.tableData = data;
                this.total = response.data.total;
                this.set_time_button = response.data.time_button
                setTimeout(() => {
                    this.listLoading = false;
                }, 0.5 * 1000);
            })
            .catch(error => {
                this.listLoading = false;
            });
        },
        changeSort(column){
         if(column.prop == "average_time_text"){
           this.listQuery.sort = "average_time"
         }else if(column.prop == "average_response_time_text"){
           this.listQuery.sort = "average_response_time"
         }else if(column.prop == "wrong_rate_text"){
           this.listQuery.sort = "wrong_rate"
         }
        if(column.order === "ascending") {
           this.listQuery.order = "asc"
         }else if (column.order === "descending"){
           this.listQuery.order = "desc"
         }
         this.handleFilter();
        },
        handleFilter() {
            this.listQuery.page = 1;
            this.listQuery.limit = 10;
            this.handleList(this.listQuery);
        },
        setTime(){
          this.setTimeShow = true;
          this.timeOptions = [];
             let data = {};
             data.config_key = "statistics.time_range";
             getTimeApi(data)
              .then(response=>{
                for(let item of response.data.data){
                  let m = {
                    value:[],
                    id:new Date()
                  }
                  let time = item.split('-')
                  m.value = time;
                  this.timeOptions.push(m);
                }
              })
              .catch(error=>{})
        },
        deleteTime(item){
          for (let i = 0;i < this.timeOptions.length; i++){
              if (this.timeOptions[i].id == item.id){
                  this.timeOptions.splice(i,1);
              }
            }
          },
        addTime(){
          let m = {
            value:["00:00","23:59"],
            id:new Date()
          }
          this.timeOptions.push(m);
        },
        removeTime(){
          this.setTimeShow = false;
        },
        closeTimeShow(){
          this.setTimeShow = false;
        },
        sureTime(){
          let data = {
            config_values:[],
            config_key:""
          }
          data.config_key = "statistics.time_range";
          for(let item of this.timeOptions){
            let time = ""
            if(!(item.value[0] =="00:00" && item.value[1] =="23:59")){
              time = item.value[0]+"-"+item.value[1];
              data.config_values.push(time)
            }
          }
          setTimeApi(data) 
          .then(response =>{
              if(response.data.code == 200){
                this.setTimeShow = false;
                this.$message.success(response.data.message)
              }
              else{
                this.$message.error(response.data.message)
              }
          })
          .catch(error=>{})
        }
    }
};
</script>
<style >
div.el-transfer .el-transfer-panel {
  width: 400px;
}
</style>
